export default function formatProduct(product) {
    let productInfo = {
        item_name: product.articlename,
        item_id: `${product.articleno}`,
        price: product.totprice,
        // item_category: product.categories,
        quantity: product.quantity,
    };

    if (product.hasOwnProperty('price') && product.price.pricedesc !== '') {
        productInfo.item_variant = product.price.pricedesc;
    }

    if (product.hasOwnProperty('item_list_name') && product.item_list_name !== '') {
        productInfo.item_list_name = product.item_list_name;
    }

    if (product.hasOwnProperty('make') && product.make.makename !== '') {
        productInfo.item_brand = product.make.makename;
    }


    return productInfo;
}
